import React from "react";
import PropTypes from "prop-types";
import { Modal } from "../migration-wrappers";
import { MODALS } from "../../utils/constants";
import EditBusinessUnitModal from "./EditBusinessUnitModal/container";
import DeleteReleaseNoteModal from "./DeleteReleaseNoteModal/container";
import Share from "./Share";
import MapRegionModal from "./MapRegion/CustomerJourney";
import HomepageModal from "./MapRegion/Homepage";
import ProjectOverviewDetails from "./ProjectOverviewDetails";

const getOpenedModal = (openedModal, data, closeModal) => {
  switch (openedModal) {
    case MODALS.SHARE:
      return <Share url={data} key="share" />;

    case MODALS.CJ_MAP_REGION:
      return <MapRegionModal rolledOutCountry={data} key="cj-map-region" />;

    case MODALS.HOMEPAGE_MAP_REGION:
      return (
        <HomepageModal rolledOutCountry={data} key="homepage-map-region" />
      );

    case MODALS.PROJECT_OVERVIEW_DETAILS:
      return (
        <ProjectOverviewDetails entry={data} key="project-overview-details" />
      );

    case MODALS.EDIT_BUSINESS_UNIT:
      return (
        <EditBusinessUnitModal
          identity={data.identity}
          onClose={closeModal}
          options={data.options}
          threshold={data.threshold}
          key="edit-business-unit"
        />
      );

    case MODALS.DELETE_RELEASE_NOTE:
      return (
        <DeleteReleaseNoteModal
          closeModal={closeModal}
          data={data}
          key="delete-release-note"
        />
      );

    default:
      return "";
  }
};

const Modals = ({ closeModal, openedModal, data }) => {
  return (
    <Modal
      closeButtonAriaLabel="Close"
      contentAriaLabel="Share dialog"
      isOpen={Boolean(openedModal)}
      onClose={closeModal}
      trapFocus
    >
      {getOpenedModal(openedModal, data, closeModal)}
    </Modal>
  );
};

Modals.propTypes = {
  closeModal: PropTypes.func.isRequired,
  data: PropTypes.any,
  openedModal: PropTypes.string,
};

export default Modals;
